import React, { useState, useEffect } from "react";
import { Skeleton, Tooltip } from "antd";
import { ICONS } from "../../../assets/icons";
import Tag from "../../../assets/customSVG/Tag";
import CrmTagIcon from "../../../assets/customSVG/crmTagIcon";
import Tags from "../../../modules/crm/components/main/contact/Tags";
import Close from "../../../assets/customSVG/Close";

const TagsSection = ({
  secondaryToggle,
  setSecondaryToggle,
  tags = [],
  loading = false,
  // handleItemClick,
  activeNav,
  addTag,
  removeTag,
  handleTagClick,
}) => {
  const [showAllTags, setShowAllTags] = useState(false);
  const [hoveredTagId, setHoveredTagId] = useState(null);

  // Display only 5 tags if showAllTags is false
  const displayTags = showAllTags ? tags : tags.slice(0, 5);
  const hasMoreTags = tags.length > 5;

  const handleAddTag = () => {
    // In a real implementation, this would open a modal to add a new tag
  };

  return (
    <div>
      <div className="flex justify-between items-center py-2">
        <div
          className="flex-row align-center sidebar-header pointer"
          onClick={() => {
            setSecondaryToggle((prev) => ({
              ...prev,
              tags: !prev?.tags,
            }));
          }}
        >
          <img
            src={ICONS?.sidebarChevronDown}
            alt="icon"
            className={`w-3 mr-2 ${
              secondaryToggle["tags"] ? "" : "rotate-180"
            }`}
          />
          <span>Tags</span>
        </div>
        <button
          className="text-blue-600 text-sm font-medium flex items-center"
          onClick={handleAddTag}
        >
          {/* <span className="mr-1">+</span> Add a Tag */}
          <Tags
            tagList={tags}
            addAction={addTag}
            // closeAction={closeAction}
            Button={
              <p className="">
                <span>Add Tag</span>
              </p>
            }
          />
        </button>
      </div>

      {secondaryToggle["tags"] && (
        <Skeleton
          active
          style={{
            width: "100%",
            padding: "10px",
          }}
          loading={loading}
          paragraph={{ rows: 2 }}
          className=".ant-skeleton-paragraph >li +li"
        >
          <div className="flex flex-col space-y-1 mt-2">
            {displayTags.map((tag) => (
              <div
                key={tag.id}
                className={`flex items-center justify-between px-3 py-2 rounded-md cursor-pointer ${
                  activeNav === tag.tag
                    ? "sidebar-sub-header-active"
                    : "sidebar-sub-header hover:bg-slate-100"
                }`}
                onClick={() => {
                  // handleItemClick(tag)
                  handleTagClick(tag);
                }}
                onMouseEnter={() => setHoveredTagId(tag.id)}
                onMouseLeave={() => setHoveredTagId(null)}
              >
                <div className="flex items-center gap-3">
                  <div className="text-gray-500">
                    {/* <tagIcon width="18" height="18" /> */}
                    <CrmTagIcon />
                  </div>
                  <p
                    className={` font14px-400 ${
                      activeNav === tag.id
                        ? "sidebar-sub-header-active"
                        : "sidebar-sub-header "
                    }`}
                  >
                    {(tag.tag || tag.name)?.charAt(0).toUpperCase() +
                      (tag.tag || tag.name)?.slice(1)}
                  </p>
                </div>
                {hoveredTagId === tag.id && (
                  <div
                    className="text-gray-400 hover:text-gray-600"
                    onClick={(e) => removeTag(tag.id)}
                  >
                    <Close
                      width="16"
                      height="16"
                      circle={false}
                      stroke="#6B7280"
                      strokeWidth="1.5"
                    />
                  </div>
                )}
              </div>
            ))}
            {hasMoreTags && (
              <div
                onClick={() => setShowAllTags(!showAllTags)}
                className="flex items-center font-normal justify-between gap-2 px-3 py-2 rounded-lg cursor-pointer hover:bg-slate-100 text-[8px] transition-colors"
              >
                <div className="flex items-center gap-2">
                  <img
                    src={ICONS?.sidebarChevronDown}
                    alt="Toggle"
                    className={`w-[10px] h-[10px] mr-2 transition-transform duration-200 ${
                      showAllTags ? "rotate-180" : "rotate-0"
                    }`}
                  />
                  <span className="text-xs font-[12px]">
                    {showAllTags ? "See Less" : "See More"}
                  </span>
                </div>
              </div>
            )}
          </div>
        </Skeleton>
      )}
    </div>
  );
};

export default TagsSection;
